$( ".submitButton" ).click(function() {
	var control = document.documentElement.getAttribute("data-bank");
	console.log(control);
	if (control  == "ISPSLOVENIA"){
	  $( ".hideTable" ).hide();
	  $(".hiddenArchiveSlo").show();
	}
});

$( "a.tab-link" ).click(function() {
	var control = document.documentElement.getAttribute("data-bank");
	console.log(control);
	if (control  == "ISPSLOVENIA"){
		 $(".hiddenArchiveSlo").hide();
		 $( ".hideTable" ).show(); 
	}
	 
});

/*window.onload=function(){
	document.getElementsByClassName("datepicker-button input-group-addon calendarTheme")[2].addEventListener("click", fixDatePicker);
}

function fixDatePicker (){
	var elementAbove = $("div.datepicker-calendar.calendarTheme.above");
	var elementBelow = $("div.datepicker-calendar.calendarTheme.below");
	if(elementAbove.length > 0){
		elementAbove.attr("style","left:0px!important;top:-360px!important");
		$(window).scrollTop(35/100);
		console.log("Desktop Above");
	}else if(elementBelow.length > 0){

		elementBelow.attr("style","left:0px!important;top:50px!important");
		$(window).scrollTop(35/100);
		console.log("Desktop Below");
	}else{
		console.log("There isn't an element");
		console.log(elementAbove.length);
		console.log(elementBelow.length);
	}
}*/

